<template lang="pug">
  .empty-panel
    .flex-wrap
      .info-box
        .main-info Users can submit recognitions so you have visibility on staff feedback.
        .check-list
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              .heading PHOTO UPLOAD
              p Users can upload a photo to support their recognition submissions.
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              .heading STAR RATING
              p A 5 star rating system for staff feedback in recognition submissions.
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              .heading DETAILED REPORTS
              p View detailed reports and analytics of all the submissions you receive.
          .check
            fa-layers.fa-2x
              fa-icon(:icon="['far','circle']" )
              fa-icon(icon="check" transform="shrink-8")
            .text-box
              .heading MANAGE RECOGNISE
              p Use Recognise to identify and reward staff for 5-star ratings
        .empty-div
      .img-box
        img(src='@/assets/images/emptystates/br-recognise.png')
    
</template>

<script>
export default {};
</script>

<style scoped lang="scss"></style>
